import { jsx as e, Fragment as n } from "react/jsx-runtime";
import { HoopsViewerContext as p } from "./HoopsViewerContext.mjs";
import "react";
import { HOOPS_LIB_URL as s } from "./HoopsViewerLoader.consts.mjs";
import { useHoopsScript as c } from "./HoopsViewerLoader.hooks.mjs";
const H = (t) => {
  const { loader: r, url: i = s, children: m } = t, { communicator: o } = c(i);
  return o ? /* @__PURE__ */ e(p.Provider, { value: o, children: m }) : r !== void 0 ? /* @__PURE__ */ e(n, { children: r }) : null;
};
export {
  H
};
//# sourceMappingURL=HoopsViewerLoader-C5p8Eh4T.js.map
